//
// uxTour.js v0.2.3
//
// https://github.com/lyngbach/uxTour
//
// Copyright 2016, Rune Lyngbach Jensen
// Email: lyngbachjensen@gmail.com
//
// licensed under MIT

var uxTour = function (options) {
  if (!window.bitcube) {
    window.bitcube = {};
  }

  window.bitcube.uxTourExists = false;
  this.options = options || {};
  this.options.padding = this.options.padding || 16;
  this.options.opacity = this.options.opacity || 0.7;
  this.options.color = this.hex2rgb(this.options.color || '#000000');
  this.options.buttonText = this.options.buttonText || 'Got it!';
  this.options.closeIcon =
    this.options.closeIcon ||
    '<svg  aria-hidden="true" focusable="false" role="presentation" width="30" height="30" class="icon icon-close-small" viewBox="0 0 12 13" fill="#000" xmlns="http://www.w3.org/2000/svg">' +
      '<path d="M8.48627 9.32917L2.82849 3.67098" stroke="#333030" stroke-linecap="round" stroke-linejoin="round"/>' +
      '<path d="M2.88539 9.38504L8.42932 3.61524" stroke="#333030" stroke-linecap="round" stroke-linejoin="round"/>' +
      '</svg>';

  this.options.frame = this.options.frame || 'circle';
  this.options.offset = this.options.offset || 100;
  this.options.image =
    this.options.image ||
    'url(https://cdn.shopify.com/s/files/1/0255/7221/2835/files/photo_Roxy_review.png?v=1674143266)';

  this.resizeTimeout;
  this.rgba = `
    rgba(${this.options.color.r}, 
    ${this.options.color.g},
    ${this.options.color.b}, 0);`;

  this.onBrowserResize = function () {
    clearTimeout(this.resizeTimeout);

    this.resizeTimeout = setTimeout(this.adjust.bind(this), 150);
  };

  window.onresize = this.onBrowserResize.bind(this);
};

uxTour.prototype.start = function (tour) {
  if (tour === undefined) {
    console.error('uxTour missing tour argument in start method');
    return false;
  }

  if (tour.steps === undefined) {
    console.error('uxTour missing steps array property on tour object');
    return false;
  }

  this.tour = tour;
  if (this.tour) {
    window.bitcube.uxTourExists = true;
  }

  if (document.getElementById('uxOverlay') === null) {
    this.overlay = document.createElement('div');
    this.highlight = document.createElement('div');
    this.tooltip = document.createElement('div');
    this.icon = document.createElement('div');
    this.paragraph = document.createElement('p');

    if (this.overlay && this.highlight && this.tooltip && this.icon && this.paragraph) {
      if (this.options.image !== 'none') {
        this.stepImage = document.createElement('div');
      }

      this.gotIt = document.createElement('button');

      this.overlay.id = 'uxOverlay';
      this.overlay.style.cssText = `position: fixed; 
      z-index: 999990; 
      top: 0; 
      left: 0; 
      width: 100%; 
      height: 100%;`;

      this.highlight.id = 'uxHighlight';
      this.highlight.style.cssText = `position: absolute; 
      z-index: 999991; 
      border-radius: ${this.options.frame === 'circle' ? '50' : '0'}%; 
      box-shadow: 0 0 0 999px ${this.rgba}; 
      top: 0; 
      left: 0; 
      ${this.getPrefix().css}transition: 0.5s ease;`;
      this.highlight.style.padding = this.options.padding + 'px';

      this.tooltip.id = 'uxTooltip';
      this.tooltip.style.cssText = `
      position: absolute; 
      z-index: 999991; 
      width: 300px; 
      max-width: 100%; 
      padding: 16px; 
      background-color: #fff; 
      opacity: 0; 
      font-size: 16px; 
      border-radius: 25px; 
      left: 0;' 
      ${this.getPrefix().css}transform: translateX(-50%); 
      ${this.getPrefix().css}transition: 0.5s ease;`;

      this.id = 'uxIcon';
      this.icon.style.cssText = `color: #000; 
      position: absolute; 
      right: 15px; 
      top: 15px; 
      cursor: pointer`;
      this.icon.innerHTML = this.options.closeIcon;

      this.id = 'uxImage';
      if (this.options.image !== 'none') {
        this.stepImage.style.cssText = `background-image: ${this.options.image}; 
      height: 100px; 
      width: 100px; 
      background-repeat: no-repeat; 
      background-size: 100px 100px; 
      margin: 0 auto;`;
      }

      this.id = 'uxParagraph';
      this.paragraph.style.cssText = `color: #000; 
      text-align: center; 
      margin: 20px 0; 
      font-size: 16px`;

      this.gotIt.id = 'uxGotIt';
      this.gotIt.style.cssText = `width: 100%; 
      justify-content: center; 
      background: #F37093; 
      color: #FFF; 
      padding: 9px 30px 11px; 
      font-size: 18px; 
      cursor: pointer; 
      border-radius: 30px; 
      display: flex; 
      margin: 0 auto; 
      font-weight: bold`;
      this.gotIt.innerHTML = this.options.buttonText;

      this.tooltip.appendChild(this.icon);
      if (this.options.image !== 'none') {
        this.tooltip.appendChild(this.stepImage);
      }
      this.tooltip.appendChild(this.paragraph);
      this.tooltip.appendChild(this.gotIt);
    }

    this.prepare();
  }
};

uxTour.prototype.prepare = function () {
  this.currentStep = 0;

  requestAnimationFrame(() => {
    if (document.getElementById('uxOverlay') === null) {
      document.body.appendChild(this.overlay);

      this.overlay.addEventListener('click', this.close.bind(this), false);
      this.icon.addEventListener('click', this.close.bind(this), false);
    }

    if (document.getElementById('uxHighlight') === null) {
      document.body.appendChild(this.highlight);

      this.highlight.addEventListener('click', this.showStep.bind(this), false);
    }

    if (document.getElementById('uxTooltip') === null) {
      document.body.appendChild(this.tooltip);

      this.gotIt.addEventListener('click', this.showStep.bind(this), false);
    }

    setTimeout(this.fadeIn.bind(this), 10);

    this.showStep();
  });
};

uxTour.prototype.showStep = function () {
  var step = this.tour.steps[this.currentStep],
    browser = this.getPrefix(),
    prefix = browser.dom === 'Moz' ? browser.js : browser.lowercase,
    documentBody = browser.lowercase === 'webkit' ? document.body : document.documentElement,
    padding,
    element,
    rect,
    marginTop,
    marginLeft;

  if (step === undefined) {
    this.close();
  } else {
    padding = step.padding ? step.padding : this.options.padding;
    element = document.getElementById(step.element);

    step.position = step.position || 'absolute';

    if (element === null) {
      this.currentStep = this.currentStep += 1;
      this.showStep();

      return false;
    }

    var frame = step.frame || this.options.frame;

    rect = element.getBoundingClientRect();

    if (rect.top === 0 && rect.right === 0 && rect.bottom === 0 && rect.left === 0) {
      this.currentStep = this.currentStep += 1;
      this.showStep();

      return false;
    }

    marginTop = rect.height / 2;
    marginLeft = rect.width / 2;

    this.highlight.style.borderRadius = frame === 'circle' ? '50' : '30px';

    if (rect.width > rect.height) {
      this.highlight.style.width = rect.width + padding * 2 + 'px';
      this.highlight.style.height =
        (frame === 'circle' ? rect.width + padding * 2 : rect.height + padding * 2) + 'px';

      if (step.position === 'fixed') {
        this.highlight.style.top = rect.top - padding + (marginTop + padding) + 'px';
      } else {
        this.highlight.style.top = rect.top + window.pageYOffset + marginTop + 'px';
      }

      this.highlight.style.left = rect.left + window.pageXOffset - padding + 'px';
      this.highlight.style[prefix + 'Transform'] = 'translate3d(0, -50%, 0)';
    } else {
      this.highlight.style.width =
        (frame === 'circle' ? rect.height + padding * 2 : rect.width + padding * 2) + 'px';
      this.highlight.style.height = rect.height + padding * 2 + 'px';

      if (step.position === 'fixed') {
        this.highlight.style.top = rect.top - padding + 'px';
      } else {
        this.highlight.style.top = rect.top + window.pageYOffset - padding + 'px';
      }

      this.highlight.style.left = rect.left + window.pageXOffset + marginLeft + 'px';
      this.highlight.style[prefix + 'Transform'] = 'translate3d(-50%, 0, 0)';
    }

    step.offset = step.offset || this.options.offset;

    this.paragraph.innerHTML = step.text;
    this.setText(step);
    this.setStyle(this.highlight, step);

    if (step.scrollIntoView !== false) {
      setTimeout(() => {
        this.tooltip.scrollIntoView();
      }, 300);
    }

    this.currentStep = this.currentStep += 1;
  }
};

uxTour.prototype.setStyle = function (element, step) {
  if (step.position) {
    element.style.position = step.position;
  } else {
    element.style.position = 'absolute';
  }
};

uxTour.prototype.inViewport = function (element) {
  var rect = element.getBoundingClientRect();

  return (
    rect.top >= 0 &&
    rect.left >= 0 &&
    rect.bottom <=
      (window.innerHeight || document.documentElement.clientHeight) /*or $(window).height() */ &&
    rect.right <=
      (window.innerWidth || document.documentElement.clientWidth) /*or $(window).width() */
  );
};

uxTour.prototype.close = function () {
  this.currentStep = 0;
  this.highlight.style.opacity = 0;
  this.tooltip.style.opacity = 0;

  setTimeout(this.fadeOut.bind(this), (window.bitcube.uxTourExists = false), 300);
};

uxTour.prototype.fadeIn = function () {
  this.boxShadow = navigator.userAgent.match(/Version\/[\d\.]+.*Safari/) ? '1900' : '9999'; // check for safari browser
  this.boxShadow = navigator.userAgent.indexOf('iPad') > -1 ? '893' : this.boxShadow; // check for iPad
  this.tooltip.style.opacity = 1;

  this.highlight.style.boxShadow = `0 0 0 ${this.boxShadow}px rgba(${this.options.color.r},${this.options.color.g},${this.options.color.b},${this.options.opacity})`;

  // Disable scrolling
  document.body.style.overflowY = 'hidden';
};

uxTour.prototype.fadeOut = function () {
  if (this.tour || window.bitcube.uxTourExists === true) {
    if (this.overlay && this.overlay.parentNode) {
      this.overlay?.parentNode?.removeChild(this.overlay);
    }

    if (this.highlight && this.highlight.parentNode) {
      this.highlight?.parentNode?.removeChild(this.highlight);
    }

    if (this.tooltip && this.tooltip.parentNode) {
      this.tooltip?.parentNode?.removeChild(this.tooltip);
    }

    // Disable scrolling
    document.body.style.overflowY = 'unset';
  }
};

uxTour.prototype.setText = function (step) {
  var element = document.getElementById(step.element),
    highlightRect = element.getBoundingClientRect(),
    tooltipRect = this.tooltip.getBoundingClientRect(),
    direction = step.direction || 'right',
    padding = step.padding || 10,
    margin = 50,
    highlightTop = window.pageYOffset + highlightRect.top,
    highlightLeft = window.pageXOffset + highlightRect.left;

  this.tooltip.style.transform = 'unset';

  switch (direction) {
    case 'left':
      this.tooltip.style.top =
        highlightTop - (tooltipRect.height - highlightRect.height - padding) + 'px';
      this.tooltip.style.left = highlightLeft - (tooltipRect.width + margin) + 'px';
      break;
    case 'right':
      this.tooltip.style.top =
        highlightTop - (tooltipRect.height - highlightRect.height - padding) + 'px';
      this.tooltip.style.left = highlightLeft + (highlightRect.width + margin) + 'px';
      break;
    case 'top':
      this.tooltip.style.top = highlightTop - (tooltipRect.height + margin) + 'px';
      this.tooltip.style.left =
        highlightLeft - tooltipRect.width / 2 + highlightRect.width / 2 + 'px';
      break;
    case 'bottom':
      this.tooltip.style.top = highlightTop + (highlightRect.height + margin) + 'px';
      this.tooltip.style.left =
        highlightLeft - tooltipRect.width / 2 + highlightRect.width / 2 + 'px';
      break;
    default:
  }
  this.setStyle(this.tooltip, step);
};

uxTour.prototype.easeInOut = function (currentTime, start, change, duration) {
  currentTime /= duration / 2;

  if (currentTime < 1) {
    return (change / 2) * currentTime * currentTime + start;
  }

  currentTime -= 1;

  return (-change / 2) * (currentTime * (currentTime - 2) - 1) + start;
};

uxTour.prototype.hex2rgb = function (color) {
  var r, g, b;

  if (color.charAt(0) == '#') {
    color = color.substr(1);
  }

  r = color.charAt(0) + '' + color.charAt(1);
  g = color.charAt(2) + '' + color.charAt(3);
  b = color.charAt(4) + '' + color.charAt(5);

  r = parseInt(r, 16);
  g = parseInt(g, 16);
  b = parseInt(b, 16);

  return {
    r: r,
    g: g,
    b: b,
  };
};

uxTour.prototype.adjust = function () {
  if (document.getElementById('uxOverlay') !== null && this.currentStep !== undefined) {
    this.currentStep = this.currentStep - 1;
    this.showStep();
  }
};

uxTour.prototype.getPrefix = function () {
  var styles = window.getComputedStyle(document.documentElement, ''),
    pre = (Array.prototype.slice
      .call(styles)
      .join('')
      .match(/-(moz|webkit|ms)-/) ||
      (styles.OLink === '' && ['', 'o']))[1],
    dom = 'WebKit|Moz|MS|O'.match(new RegExp('(' + pre + ')', 'i'))[1];

  return {
    dom: dom,
    lowercase: pre,
    css: '-' + pre + '-',
    js: pre[0].toUpperCase() + pre.substr(1),
  };
};
